let product = [
    {
        path: '/productmanage/productclassify',
        name: 'productclassify',
        component: () => import('@/views/productmanage/productclassify.vue'),
        meta: {keepAlive: true, parentPath: 'productmanage'},
    },
    {
        path: '/productmanage/productbase',
        name: 'productbase',
        component: () => import('@/views/productmanage/productbase/list.vue'),
        meta: {keepAlive: true, parentPath: 'productmanage'},
    },
    {
        path: '/productmanage/productbase/edit',
        name: 'edit',
        component: () => import('@/views/productmanage/productbase/edit.vue'),
        meta: {keepAlive: true, parentPath: 'productmanage'},
    },
    {
        path: '/productmanage/productbase/translation',
        name: 'translation',
        component: () => import('@/views/productmanage/productbase/translation.vue'),
        meta: {keepAlive: true, parentPath: 'productmanage'},
    },
    {
        path: '/productmanage/options',
        name: 'options',
        component: () => import('@/views/productmanage/options.vue'),
        meta: {keepAlive: true, parentPath: 'productmanage'},
    }
    ,
    {
        path: '/productmanage/groups',
        name: 'groups',
        component: () => import('@/views/productmanage/groups/index.vue'),
        meta: {keepAlive: true, parentPath: 'productmanage'},
    },
    {
        path: '/productmanage/groups/goods',
        name: 'goods',
        component: () => import('@/views/productmanage/groups/goods.vue'),
        meta: {keepAlive: true, parentPath: 'productmanage'},
    },
    {
        path: '/productmanage/productbrand',
        name: 'productbrand',
        component: () => import('@/views/productmanage/productbrand.vue'),
        meta: {keepAlive: true, parentPath: 'productmanage'},
    }
    
    
]
export default product


// WEBPACK FOOTER //
// ./src/router/product.js